import { Phone, AlertTriangle } from "lucide-react";

export default function EmergencyBanner() {
  return (
    <div
      data-testid="emergency-banner"
      className="bg-[#E31837] text-white text-sm"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2 flex items-center justify-center gap-3 text-center">
        <AlertTriangle className="w-4 h-4 flex-shrink-0" strokeWidth={2.4} />
        <span className="font-medium tracking-tight">
          24/7 Emergency HVAC Service in Hiawatha &amp; surrounding areas —
        </span>
        <a
          data-testid="emergency-phone-link"
          href="tel:7852880330"
          className="inline-flex items-center gap-1.5 font-semibold underline underline-offset-4 hover:no-underline"
        >
          <Phone className="w-3.5 h-3.5" />
          785-288-0330
        </a>
      </div>
    </div>
  );
}
